import script from "./portfoliotv.vue?vue&type=script&setup=true&lang=js"
export * from "./portfoliotv.vue?vue&type=script&setup=true&lang=js"

import "./portfoliotv.vue?vue&type=style&index=0&id=49934bda&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49934bda"]])

export default __exports__